var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "activity-stage wood-pieces",
    staticStyle: {
      "visibility": "hidden",
      "height": "100%",
      "overflow": "auto"
    },
    attrs: {
      "aria-label": "Activity Letters with wood pieces",
      "id": "activity-boundary"
    }
  }, [_c('div', {
    attrs: {
      "id": "dragging-container"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    ref: "woodsContainer",
    staticClass: "woods-container"
  }), _c('div', {
    ref: "exerciseWoodsContainer",
    staticClass: "exercise-woods-container"
  })]), _c('div', {
    staticClass: "letters-container"
  }, [_c('div', {
    ref: "sampleContainer",
    staticClass: "sample-container"
  }), _c('div', {
    ref: "exerciseContainer",
    staticClass: "exercise-container"
  })])]), _c('div', {
    ref: "hiddenDiv",
    staticStyle: {
      "width": "1px",
      "height": "1px",
      "z-index": "-1000",
      "position": "absolute",
      "color": "transparent"
    },
    attrs: {
      "role": "region",
      "aria-live": "assertive"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")])]), _vm.accessibilityMode ? _c('caption-reader', {
    ref: "playerInstance"
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }